import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ReducerConstants from '../constants/reducers';
import useFeatureFlags from './useFeatureFlags';
import FEATURE_FLAGS from '../constants/featureFlags';

const useTradeChange = (tradeId, setContext) => {
  const isQuickMinBidEnabled =
    useFeatureFlags(FEATURE_FLAGS.IS_MIN_BID_QUICK_BID_ENABLED) || false;

  const tradeChange = useSelector(
    state => state?.[ReducerConstants.TRADE_CHANGE]?.[tradeId],
    shallowEqual
  );
  useEffect(() => {
    if (isQuickMinBidEnabled && tradeChange?.minBidThreshold !== undefined) {
      setContext(context => ({
        ...context,
        auctionSummary: {
          ...context.auctionSummary,
          minBidThreshold: tradeChange?.minBidThreshold
        }
      }));
    }
  }, [tradeChange?.minBidThreshold, isQuickMinBidEnabled, setContext]);
};

export default useTradeChange;
